import { useEffect } from 'react';
import { clarity } from 'react-microsoft-clarity';
import { useGetUserProfile } from '../../user/useGetUserProfile';

export const useClarity = () => {
  const { userProfile } = useGetUserProfile();

  useEffect(() => {
    if (userProfile?.id) {
      clarity.identify(userProfile?.id, {
        pvm_user_logged_in: true,
        pvm_advertisement_term_agreed: userProfile.advertisementTermsAgreement,
        pvm_user_id: userProfile.id,
        pvm_user_email: userProfile.email,
        pvm_user_phone_number: userProfile.phoneNumber,
        pvm_user_region: `${userProfile.regionDepth1} ${userProfile.regionDepth2} ${userProfile.regionDepth3}`,
      });
    } else {
      clarity.identify('unknown', {});
    }
  }, [userProfile]);
};
